import type { SVGProps } from 'react';

const SvgIsg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M14 6h4c1.65 0 3 1.35 3 3v8c0 1.65-1.35 3-3 3H6c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h3c1.3 0 2.23.62 3.05 1.17l.038.025C12.742 5.625 13.313 6 14 6M9 6H6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-4c-1.3 0-2.23-.62-3.05-1.17l-.038-.025C10.258 6.375 9.687 6 9 6"
      clipRule="evenodd"
    />
    <path
      fill="currentcolor"
      d="m12.71 16.703 3-3a.996.996 0 0 0 0-1.41l-3-3a.996.996 0 1 0-1.41 1.41l1.29 1.29H9c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-1.29 1.29c-.2.2-.29.45-.29.71s.1.51.29.71c.39.39 1.02.39 1.41 0"
    />
  </svg>
);
export default SvgIsg;
